import React from "react";
// import { Formik, Form } from "formik";
// import * as Yup from "yup";
// import FormikControl from "../CustomedFields/FormikControl";
// import { useAuth } from "./../../store/auth-context";
import Barcode from "react-barcode";

// function CustomerAdd(props, ref) {
const BarcodeCustomed = (props) => {
  let showText = props.orderNumber; // + "-" + props.orderDeailID;
  return (
    <>
      <div
        className={`test ${props.className}`}
        style={{
          textAlign: "center",
          width: "190px",
          border: "1px solid #000",
          fontWeight: "bold",
          color: "black",
          margin: "2px",
        }}
      >
        <Barcode
          value={props.orderDeailID}
          displayValue={"showText"}
          height={props.height}
        />
        <div
          style={{
            textAlign: "center",
            fontSize: "11px",
            fontWeight: "bold",
            color: "black",
          }}
        >
          লিবাস টেইলার্স &nbsp; {showText}
        </div>
      </div>
    </>
  );
};

export default BarcodeCustomed;
